<template>
  <div class="index-page container">
    <n-card>
      <n-divide class="table-tools">
        <div></div>
        <n-button @click="$router.push({name: 'faqs.create'})">Добавить вопрос</n-button>
      </n-divide>
  
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'faqs.edit', params: { id: item.id, }})" />
        </template>
      </n-table>

    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'title', title: 'Вопрос', },
      { name: 'content', title: 'Ответ', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.faqs.get().then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 150px;
    --n-image-height: 150px;
  }
</style>
